module.exports = __webpack_public_path__ + "media/images/icons/filterIcon-dec888859fbc21a31df2cf7d988ef5f5.svg";